/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* =========================================================================
   Quick Add — popup to pick a variant and add to cart from product cards
   ========================================================================= */
(function () {
  var CFG = window.QuickAddConfig || {};
  // Normalize product URL prefix (root_url can yield a leading "//")
  var PREFIX = (CFG.productPrefix || '/products/').replace(/\/{2,}/g, '/');
  var overlay, body;
  var product = null;        // product JSON from /products/{handle}.js
  var selected = {};         // optionIndex -> chosen value
  var currentVariant = null;
  var currentSizeChart = ''; // size chart image url (from the card button)
  var slideImages = [];      // all product image srcs in slider order

  function normSrc(s) { return String(s || '').replace(/^https?:/, '').split('?')[0]; }

  function money(cents) {
    var format = CFG.moneyFormat || '{{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    var value = '';
    switch (m[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ensureRefs() {
    overlay = document.getElementById('QuickAddOverlay');
    if (overlay) body = overlay.querySelector('[data-quick-add-body]');
    return !!overlay;
  }

  function openOverlay() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('QuickAdd--open');
  }
  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('QuickAdd--open');
  }

  // Find the variant matching every currently selected option
  function matchVariant() {
    if (!product) return null;
    return product.variants.filter(function (v) {
      return product.options.every(function (opt, i) {
        return v['option' + (i + 1)] === selected[i];
      });
    })[0] || null;
  }

  function renderPrice() {
    var el = body.querySelector('[data-qa-price]');
    if (!el) return;
    var v = currentVariant;
    if (!v) { el.innerHTML = ''; return; }
    var html = '<span class="QuickAdd__PriceNow">' + money(v.price) + '</span>';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      html += ' <span class="QuickAdd__PriceWas">' + money(v.compare_at_price) + '</span>';
    }
    el.innerHTML = html;
  }

  function goToSlide(i) {
    var track = body.querySelector('[data-qa-track]');
    if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }

  function setActiveDot(i) {
    body.querySelectorAll('[data-qa-dot]').forEach(function (d, di) {
      d.classList.toggle('is-active', di === i);
    });
  }

  function setupSlider() {
    var track = body.querySelector('[data-qa-track]');
    if (!track) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      setActiveDot(i);
    }, { passive: true });
  }

  function refreshState() {
    currentVariant = matchVariant();
    renderPrice();
    // Slide to the selected variant's image, if it has one
    if (currentVariant && currentVariant.featured_image) {
      var vsrc = normSrc(currentVariant.featured_image.src);
      var idx = slideImages.map(normSrc).indexOf(vsrc);
      if (idx >= 0) goToSlide(idx);
    }
    var btn = body.querySelector('[data-qa-add]');
    var buy = body.querySelector('[data-qa-buy]');
    if (!btn) return;
    var ok = currentVariant && currentVariant.available;
    if (!currentVariant) {
      btn.disabled = true; btn.textContent = CFG.strings.unavailable || 'Unavailable';
    } else if (!currentVariant.available) {
      btn.disabled = true; btn.textContent = CFG.strings.soldOut || 'Sold out';
    } else {
      btn.disabled = false; btn.textContent = CFG.strings.addToCart || 'Add to cart';
    }
    if (buy) { buy.disabled = !ok; buy.textContent = 'Buy it now'; }
  }

  function renderProduct() {
    // product.options may be an array of strings or of {name, values} objects
    var optionNames = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    selected = {};
    optionNames.forEach(function (name, i) { selected[i] = first['option' + (i + 1)]; });

    var featured = (first && first.featured_image && first.featured_image.src) ||
      (product.featured_image) || (product.images && product.images[0]) || '';

    // All product images for the slider
    slideImages = (product.images && product.images.length) ? product.images.slice() : (featured ? [featured] : []);
    var slidesHtml = slideImages.map(function (src) {
      return '<div class="QuickAdd__Slide"><img src="' + esc(src) + '" alt="' + esc(product.title) + '" loading="lazy"></div>';
    }).join('');
    var dotsHtml = slideImages.length > 1 ? slideImages.map(function (_, i) {
      return '<button type="button" class="QuickAdd__Dot' + (i === 0 ? ' is-active' : '') + '" data-qa-dot="' + i + '" aria-label="Go to image ' + (i + 1) + '"></button>';
    }).join('') : '';
    var mediaHtml = '<div class="QuickAdd__Media"><div class="QuickAdd__Slider">' +
      '<div class="QuickAdd__Track" data-qa-track>' + slidesHtml + '</div>' +
      (dotsHtml ? '<div class="QuickAdd__Dots" data-qa-dots>' + dotsHtml + '</div>' : '') +
      '</div></div>';

    var optionsHtml = '';
    // Only render selectors when the product actually has variants (not the single default)
    var hasRealOptions = !(optionNames.length === 1 && optionNames[0].toLowerCase() === 'title' && product.variants.length === 1);
    if (hasRealOptions) {
      optionNames.forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (i + 1)];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="QuickAdd__Option" data-qa-option="' + i + '">' +
          '<span class="QuickAdd__OptionName">' + esc(name) + '</span>' +
          '<div class="QuickAdd__Values">' +
          values.map(function (val) {
            var isSel = selected[i] === val ? ' is-selected' : '';
            return '<button type="button" class="QuickAdd__Value' + isSel + '" data-qa-opt-index="' + i + '" data-qa-opt-value="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('') +
          '</div></div>';
      });
    }

    body.innerHTML =
      mediaHtml +
      '<div class="QuickAdd__Details">' +
        '<h3 class="QuickAdd__Title">' + esc(product.title) + '</h3>' +
        '<div class="QuickAdd__Price" data-qa-price></div>' +
        optionsHtml +
        '<button type="button" class="QuickAdd__SizeGuideLink" data-qa-size-guide>' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 16l5-5 4 4 5-5 4 4M3 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          'Size guide</button>' +
        '<div class="QuickAdd__Qty"><label>Qty</label>' +
          '<input type="number" min="1" value="1" data-qa-qty inputmode="numeric"></div>' +
        '<button type="button" class="QuickAdd__Add" data-qa-add>' + (CFG.strings.addToCart || 'Add to cart') + '</button>' +
        '<button type="button" class="QuickAdd__Buy" data-qa-buy>Buy it now</button>' +
        '<a class="QuickAdd__ViewLink" href="' + esc(PREFIX + product.handle) + '">' + (CFG.strings.viewDetails || 'View full details') + '</a>' +
        '<p class="QuickAdd__Error" data-qa-error hidden></p>' +
      '</div>' +
      '<div class="QuickAdd__SizeChart" data-qa-sc-overlay hidden>' +
        '<div class="QuickAdd__SizeChartInner">' +
          '<button type="button" class="QuickAdd__SizeChartClose" data-qa-sc-close aria-label="Close size guide">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<div class="QuickAdd__SizeChartBody" data-qa-sc-body></div>' +
        '</div></div>';

    setupSlider();
    refreshState();
  }

  // ---- Size guide (pulls the chart from the BF "Size Charts by Relentless" app) ----
  var sizeChartCache = {}; // handle -> chart object, or false when none

  function extractChart(html) {
    var m = html.match(/<script>\s*(var sizeChartsRelentless[\s\S]*?)<\/script>/);
    if (!m) return null;
    try { (0, eval)(m[1]); } catch (e) { return null; }
    var scr = window.sizeChartsRelentless || {};
    var chart = (scr.metafield && scr.metafield.chart) || null;
    if (!chart && scr.blocks) {
      var keys = Object.keys(scr.blocks);
      if (keys.length) chart = scr.blocks[keys[0]];
    }
    if (!chart || !chart.values || !chart.values.length) return null;
    return chart;
  }

  function chartHasData(chart) {
    return chart && chart.values && chart.values.some(function (row) {
      return row && row.some(function (c) { return String(c || '').replace(/<br\s*\/?>/gi, '').trim() !== ''; });
    });
  }

  function buildSizeTable(chart) {
    var rows = chart.values || [];
    var html = '';
    if (chart.title) html += '<h4 class="QuickAdd__SizeChartTitle">' + esc(chart.title) + ' — Size Guide</h4>';
    if (chart.descriptionTop) html += '<div class="QuickAdd__SizeChartDesc">' + chart.descriptionTop + '</div>';
    html += '<div class="QuickAdd__SizeTableWrap"><table class="QuickAdd__SizeTable">';
    rows.forEach(function (row, ri) {
      var tag = ri === 0 ? 'th' : 'td';
      html += '<tr>' + row.map(function (cell, ci) {
        var cls = (ri !== 0 && ci === 0) ? ' class="QuickAdd__SizeRowLabel"' : '';
        return '<' + tag + cls + '>' + (cell == null ? '' : String(cell)) + '</' + tag + '>';
      }).join('') + '</tr>';
    });
    html += '</table></div>';
    if (chart.descriptionBottom) html += '<div class="QuickAdd__SizeChartDesc">' + chart.descriptionBottom + '</div>';
    return html;
  }

  function renderSizeGuide(chart) {
    var scBody = body.querySelector('[data-qa-sc-body]');
    if (!scBody) return;
    scBody.innerHTML = chart ? buildSizeTable(chart)
      : '<div class="QuickAdd__Loader">No size guide available for this product.</div>';
  }

  function openSizeGuide() {
    var overlay2 = body.querySelector('[data-qa-sc-overlay]');
    if (!overlay2) return;
    overlay2.hidden = false;
    var handle = product && product.handle;
    if (sizeChartCache[handle] !== undefined) { renderSizeGuide(sizeChartCache[handle]); return; }
    var scBody = body.querySelector('[data-qa-sc-body]');
    if (scBody) scBody.innerHTML = '<div class="QuickAdd__Loader">Loading size guide…</div>';
    fetch(PREFIX + handle, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var chart = extractChart(html);
        if (chart && !chartHasData(chart)) chart = null;
        sizeChartCache[handle] = chart || false;
        renderSizeGuide(sizeChartCache[handle]);
      })
      .catch(function () { renderSizeGuide(false); });
  }

  function addToCart() {
    if (!currentVariant) return;
    var qtyEl = body.querySelector('[data-qa-qty]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var btn = body.querySelector('[data-qa-add]');
    var errEl = body.querySelector('[data-qa-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(CFG.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (errEl) { errEl.hidden = false; errEl.textContent = (res.data && res.data.description) || 'Could not add to cart.'; }
          refreshState();
          return;
        }
        // Notify the theme so the mini-cart updates, then open the drawer
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: currentVariant, quantity: qty }
        }));
        closeOverlay();
        var trigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
        if (trigger) { setTimeout(function () { trigger.click(); }, 60); }
      })
      .catch(function () {
        if (errEl) { errEl.hidden = false; errEl.textContent = 'Network error. Please try again.'; }
        refreshState();
      });
  }

  function buyNow() {
    if (!currentVariant) return;
    var qtyEl = body.querySelector('[data-qa-qty]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var buyBtn = body.querySelector('[data-qa-buy]');
    var errEl = body.querySelector('[data-qa-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = '…'; }

    fetch(CFG.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (errEl) { errEl.hidden = false; errEl.textContent = (res.data && res.data.description) || 'Could not proceed to checkout.'; }
          refreshState();
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        if (errEl) { errEl.hidden = false; errEl.textContent = 'Network error. Please try again.'; }
        refreshState();
      });
  }

  function loadProduct(handle, sizeChart) {
    if (!ensureRefs()) return;
    product = null; currentVariant = null;
    currentSizeChart = sizeChart || '';
    slideImages = [];
    body.innerHTML = '<div class="QuickAdd__Loader">Loading…</div>';
    openOverlay();
    fetch(PREFIX + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { product = data; renderProduct(); })
      .catch(function () {
        body.innerHTML = '<div class="QuickAdd__Loader">Sorry, this product could not be loaded.</div>';
      });
  }

  // ---- Event delegation ----
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      loadProduct(trigger.getAttribute('data-product-handle'), trigger.getAttribute('data-size-chart'));
      return;
    }
    if (e.target.closest('[data-quick-add-close]')) { closeOverlay(); return; }
    if (ensureRefs() && e.target === overlay) { closeOverlay(); return; }

    // Slider dots
    var dot = e.target.closest('[data-qa-dot]');
    if (dot && body && body.contains(dot)) {
      var di = parseInt(dot.getAttribute('data-qa-dot'), 10);
      goToSlide(di); setActiveDot(di);
      return;
    }

    // Size guide open/close
    if (e.target.closest('[data-qa-size-guide]')) { openSizeGuide(); return; }
    if (e.target.closest('[data-qa-sc-close]')) { var o = body.querySelector('[data-qa-sc-overlay]'); if (o) o.hidden = true; return; }
    var scO = e.target.closest('[data-qa-sc-overlay]');
    if (scO && e.target === scO) { scO.hidden = true; return; }

    var val = e.target.closest('[data-qa-opt-value]');
    if (val && body && body.contains(val)) {
      var idx = parseInt(val.getAttribute('data-qa-opt-index'), 10);
      selected[idx] = val.getAttribute('data-qa-opt-value');
      body.querySelectorAll('[data-qa-option="' + idx + '"] .QuickAdd__Value').forEach(function (b) {
        b.classList.toggle('is-selected', b === val);
      });
      refreshState();
      return;
    }

    if (e.target.closest('[data-qa-add]')) { addToCart(); return; }
    if (e.target.closest('[data-qa-buy]')) { buyNow(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) closeOverlay();
  });
})();